module.exports = __webpack_public_path__ + "static/img/7.67b75f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/7.png
// module id = o/m9
// module chunks = 0